import { atom } from "jotai";
import { ToastProps } from "./Toast";

export interface ToastInvocation {
  key: string;
  toast: ToastProps;
  timeout: number | null;
  isDismissing: boolean;
}

export const toastsAtom = atom<ToastInvocation[]>([]);
